// actions types
const SET_STATE_LIST = 'SET_STATE_LIST';
const SET_COUNTRY_LIST = 'SET_COUNTRY_LIST';

// action creators
export function saveStateList(payload) {
  return { type: SET_STATE_LIST, payload };
}

export function saveCountryList(payload) {
  return { type: SET_COUNTRY_LIST, payload };
}

export const odataInitialState = {
  countryList: [],
  soldTo: {
    stateList: []
  },
  shipTo: [{ stateList: [] }],
  billTo: {
    stateList: []
  },
  payer: {
    stateList: []
  },
  bankReference: {
    stateList: []
  }
};
// reducer
export function odata(state, action) {
  if (!state) {
    state = odataInitialState;
  }
  switch (action.type) {
    case SET_STATE_LIST: {
      const { dataList, cardCategory, index } = action.payload;
      if (cardCategory === 'shipTo') {
        const tempShipTo = state.shipTo;
        tempShipTo[index] = {
          stateList: dataList.map(state => ({
            label: state.StateDesc,
            value: state.StateKey
          }))
        };
        return {
          ...state,
          cardCategory: tempShipTo
        };
      }
      return {
        ...state,
        [cardCategory]: {
          stateList:
            dataList &&
            dataList.map(state => ({
              label: state.StateDesc,
              value: state.StateKey
            }))
        }
      };
    }
    case SET_COUNTRY_LIST:
      return {
        ...state,
        countryList: action.payload?.dataList?.map(country => ({
          label: country.CountryName,
          value: country.CountryKey
        }))
      };
    default:
      return state;
  }
}
